import React from "react"
import styles from "./cmmcjoinus.css"

const CMMCJoinus = (props) => {

  return (
    <section className="join" id="Joinus">
      
      <div className="joinuswrap">
      <div className="containfix">
        <div className="joinus">
          <div className="jtext">
            JOIN US!
          </div>
          <div className="colcenter"></div>
          <div className="regcol">
            <a className="regop" href="https://event.on24.com/wcc/r/2708333/0DC7694A1E568E2D2B3AA459933CFEE9" target="_blank">REGISTER »</a>
          </div>
        </div>
      </div>
      </div>
    </section>
  )
}

export default CMMCJoinus